import * as GeneralRepository from "./general-repository";
import * as FamiliarProvider from "../providers/familiar-provider";

export const obtenerFamiliares = async (idSolicitudMultiple) => {
    const response = await FamiliarProvider.obtenerFamiliares(idSolicitudMultiple)
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            familiares: response.entity.data
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await obtenerFamiliares(idSolicitudMultiple)
            } else {
                return {
                    error: response.auditResponse,
                    familiares: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                familiares: null
            }
        }
    }
}

export const guardarFamiliar = async (familiar) => {
    let response = null
    if(familiar.idFamiliar !== undefined && familiar.idFamiliar !== null && familiar.idFamiliar !== 0) {
        response = await FamiliarProvider.actualizarFamiliar(familiar.idSolicitudMultiple, familiar)
    } else {
        response = await FamiliarProvider.registrarFamiliar(familiar.idSolicitudMultiple, familiar)
    }

    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            familiar: response.entity.data
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await guardarFamiliar(familiar)
            } else {
                return {
                    error: response.auditResponse,
                    familiar: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                familiar: null
            }
        }
    }
}

export const eliminarFamiliar = async (familiar) => {
    const response = await FamiliarProvider.eliminarFamiliar(familiar.idSolicitudMultiple, familiar)
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            familiar: response.entity.data
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await eliminarFamiliar(familiar)
            } else {
                return {
                    error: response.auditResponse,
                    familiar: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                familiar: null
            }
        }
    }
}

export const obtenerFamiliar = async (idSolicitudMultiple, familiar) => {
    const response = await FamiliarProvider.obtenerFamiliar(idSolicitudMultiple, familiar)
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            familiares: response.entity.data
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await obtenerFamiliar(idSolicitudMultiple)
            } else {
                return {
                    error: response.auditResponse,
                    familiares: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                familiares: null
            }
        }
    }
}

export const guardarFamiliarAdicional = async (idSolicitudMultiple, familiar) => {
    let response = null
    if(familiar.idFamiliar !== undefined && familiar.idFamiliar !== null && familiar.idFamiliar !== 0) {
        response = await FamiliarProvider.actualizarFamiliarAdicional(idSolicitudMultiple, familiar)
    } else {
        response = await FamiliarProvider.registrarFamiliar(idSolicitudMultiple, familiar)
    }

    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            familiar: response.entity.data
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await guardarFamiliarAdicional(familiar)
            } else {
                return {
                    error: response.auditResponse,
                    familiar: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                familiar: null
            }
        }
    }
}


export const guardarFamiliarAdicionalDeclaracion = async (idSolicitudMultiple, familiar) => {
    let response = await FamiliarProvider.registrarFamiliarDeclaracion(idSolicitudMultiple, familiar)

    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            familiar: response.entity.data
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await guardarFamiliarAdicionalDeclaracion(familiar)
            } else {
                return {
                    error: response.auditResponse,
                    familiar: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                familiar: null
            }
        }
    }
}


export const obtenerFamiliaresAdjuntosTipo = async (idSolicitudMultiple, idFamliar, tipo) => {
    const response = await FamiliarProvider.obtenerFamiliaresAdjuntosTipo(idSolicitudMultiple, idFamliar, tipo)
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            familiares: response.entity.data
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await obtenerFamiliaresAdjuntosTipo(idSolicitudMultiple)
            } else {
                return {
                    error: response.auditResponse,
                    familiares: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                familiares: null
            }
        }
    }
}

export const guardarFamiliarCargaDocumento = async (idSolicitudMultiple, familiar, archivo) => {
    let response = await FamiliarProvider.registrarFamiliarCargaDocumento(idSolicitudMultiple, familiar, archivo)

    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            familiar: response.entity.data
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await guardarFamiliarCargaDocumento(familiar)
            } else {
                return {
                    error: response.auditResponse,
                    familiar: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                familiar: null
            }
        }
    }
}